/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { FormContext } from "./form-context";
import { useFormReducer } from "./form-reducer";

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 */
export function FormProvider (props) {
    
    const { children } = props;
    const [state, dispatch] = useFormReducer();
    const context = {
        state, dispatch
    };
    
    return (
        <FormContext.Provider value={ context }>
            {children}
        </FormContext.Provider>
    );
}
